import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Stack, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { quickActions } from "../dashboardData";

const QuickActionsRow = () => {
  const navigate = useNavigate();

  return (
    <Stack direction="row" spacing={1.5} flexWrap="wrap" sx={{ mb: 2.75 }}>
      {quickActions.map(({ label, path }) => (
        <Paper
          key={label}
          variant="outlined"
          onClick={path ? () => navigate(path) : undefined}
          sx={{
            flex: "1 1 160px",
            minWidth: 160,
            display: "flex",
            alignItems: "center",
            gap: 1.25,
            p: "13px 16px",
            borderRadius: "12px",
            cursor: path ? "pointer" : "default",
            fontWeight: 600,
            fontSize: 13,
            "&:hover": path ? { borderColor: "#4b1f6b" } : undefined,
          }}
        >
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: "8px",
              bgcolor: "#4b1f6b",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <AddIcon fontSize="small" />
          </Box>
          <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{label}</Typography>
        </Paper>
      ))}
    </Stack>
  );
};

export default QuickActionsRow;
